
import React from 'react';
import { Button } from '@/components/ui/button';
import { Languages } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { language, setLanguage, t } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'zh' ? 'en' : 'zh');
  };

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className="text-slate-400 hover:text-white flex items-center gap-2"
    >
      <Languages className="w-4 h-4" />
      <span className="text-sm">
        {language === 'zh' ? '中' : 'EN'}
      </span>
    </Button>
  );
};

export default LanguageSwitcher;
